// Read URL params
const params = Object.fromEntries(new URLSearchParams(window.location.search));

const {
  mode = 'place',
  query = '',
  origin = '',
  destination = '',
  height = 300,
  width = '100%',
  zoom = 16,
  language = 'en',
  mapType = 'roadmap',
  center = '',
} = params;

// Build the map URL
const getMapUrl = () => {
  const apiKey = import.meta.env.VITE_GOOGLE_EMBED_API_KEY;

  if (!apiKey) {
    console.error('Google Maps API key is missing');
    return null;
  }

  if (mode === 'directions') {
    // Validate required params for directions
    if (!origin || !destination) {
      console.error('Origin and destination are required for directions mode');
      return null;
    }
    return `https://www.google.com/maps/embed/v1/directions?key=${apiKey}&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}&zoom=${zoom}&maptype=${mapType}&language=${language}`;
  }
  // Validate required params for place mode
  if (!query) {
    console.error('Query is required for place mode');
    return null;
  }

  return `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${encodeURIComponent(query)}&center=${center}&zoom=${zoom}&maptype=${mapType}&language=${language}`;
};

// Get the map URL
const mapUrl = getMapUrl();

// Only create iframe if URL is valid
if (mapUrl) {
  const iframe = document.createElement('iframe');
  iframe.title = 'Google map';
  iframe.width = width;
  iframe.height = height;
  iframe.loading = 'lazy';
  iframe.allowFullscreen = true;
  iframe.referrerPolicy = 'no-referrer-when-downgrade';
  iframe.style.border = '0';
  iframe.src = mapUrl;

  // Inject iframe into the root div
  const root = document.getElementById('embedded-map-root');
  root.appendChild(iframe);
} else {
  console.error('Failed to generate map URL');
}
